<template>
  <ul class="list-inline mb-0 lang">
    <li class="list-inline-item"><a @click="changeLocale('ka')" class="c-pointer text-decoration-none">ქარ</a></li>
    <li class="list-inline-item"><a @click="changeLocale('en')" class="c-pointer text-decoration-none">Eng</a></li>
  </ul>
</template>

<script>
export default {
  name: 'LanguageSwitcher',

  methods: {
    changeLocale (locale) {
      this.$store.dispatch('localization/setLocale', locale)
    }
  }
}
</script>

<style scoped>

</style>
